import ApiError from '@/helpers/ApiError';
import { logError } from '@/providers/ErrorTracking';
import noodleApiClient from '@/tsClient/servers/selfApi';

type Data = Record<string, unknown> & {
  message?: never;
};

const loggerError = async (message: string, data: Data): Promise<void> => {
  const path = '/logger/error';
  try {
    await noodleApiClient.post(path, { ...data, message });
  } catch (error) {
    logError(ApiError.create(error));
  }
};

export default loggerError;
